// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9 1.84229L15 5.38567L22 2.49999V18.0744L15 22.1577L9 18.6143L2 21.5V5.92562L9 1.84229Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-outline-filled')
export default class MapOutlineFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-outline-filled',
    }
  }
}
